import React, { useCallback, useMemo, useEffect } from 'react'

import { useResultsMap } from '../../search/hooks'
import { BASE_URL } from '../../constants'
import { useEsri } from '../hooks'

import GraphicLayer from './GraphicLayer'

const getResultSymbol = (isHovered, isSelected) => {
  return isHovered
    ? {
        type: 'picture-marker', // autocasts as new SimpleLineSymbol()
        url: `${BASE_URL}images/icons/pinFlagSelected.png`,
        width: '32px',
        height: '48px',
        yoffset: 24,
      }
    : isSelected
    ? {
        type: 'picture-marker', // autocasts as new SimpleLineSymbol()
        url: `${BASE_URL}images/icons/pinFlagSelected.png`,
        width: '32px',
        height: '48px',
        yoffset: 24,
      }
    : {
        type: 'picture-marker', // autocasts as new SimpleLineSymbol()
        url: `${BASE_URL}images/icons/pinFlag.png`,
        width: '32px',
        height: '48px',
        yoffset: 24,
      }
}

const getResultGeometry = (result) => ({
  type: 'point',
  x: result.location.longitude,
  y: result.location.latitude,
})

const getResultAttributes = (result) => ({
  id: result.id,
})

const AddressSearchLayer = ({ map, view }) => {
  const [{ results, selected }, { select, clear }] = useResultsMap()

  const getIsSelected = useCallback(
    (graphic) =>
      selected.ids.length &&
      selected.ids[selected.current] === graphic.attributes.id,
    [selected]
  )

  const graphics = useMemo(
    () =>
      results.flatMap((result) => {
        const isSelected =
          selected.ids.length && selected.ids[selected.current] === result.id
        return {
          geometry: getResultGeometry(result),
          symbol: getResultSymbol(false, isSelected),
          attributes: getResultAttributes(result),
        }
      }),
    [results, selected]
  )

  const onSelect = useCallback(
    (graphics) => {
      if (
        !selected.ids.some((id) => graphics.some((g) => g.attributes.id === id))
      ) {
        select(graphics.map((g) => g.attributes.id))
      }
    },
    [select, selected]
  )

  const onDeselect = useCallback(() => {
    clear()
  }, [clear])

  // Zoom/pan on selection change
  useEffect(() => {
    if (selected.ids.length) {
      const id = selected.ids[selected.current]
      const graphic = graphics.find((g) => g.attributes.id === id)
      if (graphic && graphic.geometry) {
        view.goTo({
          center: [graphic.geometry.x, graphic.geometry.y],
          zoom: 15,
        })
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selected, view]) // only update when selection changes

  return (
    <GraphicLayer
      id="addressSearchLayer"
      map={map}
      view={view}
      graphics={graphics}
      getIsSelected={getIsSelected}
      onSelect={onSelect}
      onDeselect={onDeselect}
    />
  )
}

export default AddressSearchLayer
